export const conjunctions = [
  {
    id: 'koordinierende-konj',
    category: 'konjunktionen',
    level: 'A2',
    title: 'Koordinierende Konjunktionen (Lidhëzat Bashkërenditëse - ADUSO)',
    detailedContent: `
      <section>
        <p>Lidhëzat bashkërenditëse (Koordinierende) u quajn si gjuha lidhëzash normale. Pse? Sepse ato lidhin bashkë dy fjali pa prishur asnjë rregull ! Secila mund the qëndroj e pavarur. Ato thelbezgjedhin një <b>Pozicionin 0</b> (Zero).</p>

        <h3>Rregulli POZICIONI 0</h3>
        <p>Kjo do të thotë që fjalët vijuese mbeten me Subjektin thelb tek vendi 1 thelbesor the <b>Folja thelbin thelbit nw Pozicionin e gjahtesisë (Pozita 2)</b> si rrjedhoje.</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Formula ADUSO:</strong> <b>A</b>ber (por), <b>D</b>enn (sepse), <b>U</b>nd (dhe), <b>S</b>ondern (porse / në vend t kësjtij), <b>O</b>der (ose).
        </div>

        <h3>Shembuj Strukturorë e Kuptimorë (Formula A-D-U-S-O)</h3>
        <ul>
          <li><b>Aber (por):</b> <i>Ich bin müde, <b>aber (0)</b> ich (1) lerne (2) Deutsch.</i> </li>
          <li><b>Denn (sepse):</b> Përdorm thelbesisht në bisedë pr shkak, jo në thelbet subordinete nFund folje.. <i>Er bleibt zu Hause, <b>denn</b> er <b>ist</b> krank.</i> (Kujdes: wweil-ja do ta drgonte as foljen "ist" thelbesisht tek fundi. Denn u le ne pozicion2!).</li>
          <li><b>Und (dhe):</b> Bashkangjisht e shtojsë. <i>Ich koche <b>und</b> er wäscht das Geschirr ab.</i></li>
          <li><b>Sondern (por / "but rather"):</b> Përdoret EXCLUSIVISHT pas një fjalie të MOHUESHME (me "nicht" ose "kein") për ta dresuar thelbin m mbapshtr. <i>Das ist <b>kein</b> Hund, <b>sondern</b> ein Wolf! (ky nuk s'ash t qeni, po asht ujku)! Ich gehe <b>nicht</b> ins Kino, <b>sondern</b> ich bleibe zu Hause.</i></li>
          <li><b>Oder (apo/ose):</b> Mëdyshas alternative. <i>Trinken Sie Tee <b>oder</b> Kaffe?</i></li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: [
      { question: 'Pse thuhet "denn ich bin" (denn) vlersuar te "weil ich bin" si te gabuar (weil ich bin)?', options: ['"denn" ruan poziciin zero ndaj folja rrgullishte rri i dyti. Nersa weil asht me e madhe rregill subordinati, i flak foljet thelbesisht në fund.'], correct: 0, explanation: 'Thelbi "ADUSO" jep lirin te ruhet qendersia klasike Subjekt (1) folje 2.' }
    ]
  },
  {
    id: 'subordinierende-konj',
    category: 'konjunktionen',
    level: 'B1',
    title: 'Subordinierende Konjunktionen (Lidhëzat Nënrenditëse / Rregulli i Fundit)',
    detailedContent: `
      <section>
        <p>Këto lidhëza janë "Drejtoreshat" thelbësore të fjalive të ndërvarura (Nebensätze) gjuhes gjermane. Sapo nëndgjoni thelbet a syreve a veshme e tyre në hyrje, duhet ta dini që <b>TË GJITHA FOLJET E ZGJEDHUARA FSHIHEN ABSOLUT DRITASH TEK POZICIONI I SË FUNDMIT</b> THELBSOR I ASJ FJALISË.</p>

        <h3>Rregulli Kyç i Nebensatz (Fjali Nërenditëse)</h3>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Formula Kyçe:</strong> [Fjali Kryesore], [Lidhëz Nënrenditëse] + [Subjekti] + ... + <b>[Folja Krysore Ezgjedhurar NE Absolute Fundit]</b>.
        </div>

        <h3>Lidhëzat Nënrenditëse Thelbesore që flakin foljet në thelb:</h3>
        <ul>
          <li><b>weil</b> / <b>da</b> (sepse, për dëgjesë arsye). <i>Ich lerne Deutsch, <b>weil</b> ich in Berlin leben <b>will</b>. (Une msoj thellsepse dua T jetoi ne blin. -Folja zgjedhur WILL ikte thell fund-).</i> Dhe "da" eshte poashtu si weil po vjet me thelbe letrare ne fjali fillim. <i><b>Da</b> er zu spät kam, begann die Konferenz ohne ihn.</i></li>
          <li><b>dass</b> (se). Tregon pohim/deshire fakti qe duhet lleshosh fjal. <i>Ich hoffe, <b>dass</b> das Wetter besser <b>wird</b>. (Und shpresoj SE do beht më mire Thelbi Mot).</i></li>
          <li><b>wenn / falls</b> (nëse / ndonjse kurrje thelb kohe t ardhme/t tashmtes - Kushte). <i>Du wirst krank, <b>wenn</b> du keine Jacke <b>trägst</b>.</i> (Kusht thelbsoj asht veshetnja. wjen ne t ardhten. Kujdes: ALS vjen për Thelbesit T shkuars (als ich kind war -jo- wenn i kid war)).</li>
          <li><b>obwohl</b> (edhe pse). Pranojm thell komromise faksuale te thate. <i>Er kaufte das Auto, <b>obwohl</b> es sehr theuer <b>war</b>.</i></li>
          <li><b>damit</b> (në mënyrë që / me qëllim që). Jiphet arsyesimi i thelbes per dike tjeter. <i>Ich helfe dir, <b>damit</b> du den Test <b>bestehst</b>.</i></li>
          <li><b>bevor</b> / <b>nachdem</b> / <b>während</b> / <b>seitdem / bis</b> (thelbe kohore e lidhshesme). </li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [
      { ger: 'Ich weiß, dass du Recht hast.', alb: 'Unë e di, <b>se</b> ti <b>ke</b> të drejtë. (folja HAST flaket thell pas thelesisht te fjalis asaj)' },
      { ger: 'Als ich nach Hause ankam, regnete es.', alb: '<b>Kur</b> mbërrinta thelbesht pas shtepi. binte Thelb. (Thelbi kyesot Als e ka thelbin si Lidhz Thelbesh e shkuar)' }
    ],
    exercises: [
      { question: 'Zejeni vendin thellesore the thenies: "Ich komme Thelb nicht, ... ich arbeiten (muss / thelb / ne vend) .', options: ['weil ich muss arbeiten.', 'weil ich arbeiten muss.'], correct: 1, explanation: 'Rreguli kryes i foljes se zhgjedhur (muss-Folja modelale veta ich) hidhte Thelbsesht tek vendi fundit te absolute para pikes pas Lidhires Sub.' }
    ]
  }
];
